import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { isSoftwareVersionSupported, useSoftwareVersion } from 'src/Libs/home-power-station'

const FARM_FEATURE_REQUIRED_SOFTWARE_VERSION_FLOW = '2026.01'

const useIsFarmFeatureAvailableForFlowInstallation = (): boolean => {
  const { softwareVersion } = useSoftwareVersion()
  const {
    featureFlags: { farmConfigurationEnabledForFlow },
    isFeatureFlagsLoading,
  } = useFeatureFlagsContext()

  const isFarmFeatureAvailableForFlowInstallation =
    isSoftwareVersionSupported(FARM_FEATURE_REQUIRED_SOFTWARE_VERSION_FLOW, softwareVersion) &&
    farmConfigurationEnabledForFlow &&
    !isFeatureFlagsLoading

  return isFarmFeatureAvailableForFlowInstallation
}

export default useIsFarmFeatureAvailableForFlowInstallation
